<template>
  <div id="page-editor">
    <Header id="header" :pageId="id" />

    <SideNav id="sidenav" />

    <PageEditor />

    <Overlay v-if="overlay.component" />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'

import Header from '@/components/header'
import SideNav from '@/components/SideNav.vue'
import PageEditor from '@/components/PageEditor.vue'
import Overlay from '@/components/Overlay.vue'
import { changeJavascript } from '@/helpers/javascriptHelper.js'

export default {
  i18nOptions: { keyPrefix: 'views.page-editor' },
  components: { Header, PageEditor, SideNav, Overlay },
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapState('ui', ['overlay']),
    ...mapState('settings', ['javascript']),
    ...mapGetters('history', ['hasUnsaveChanges']),
  },
  methods: {
    ...mapActions('settings', ['saveSettings']),
  },
  created() {
    changeJavascript(document, this.javascript)
    window.onbeforeunload = e => {
      if (this.hasUnsaveChanges) {
        e.preventDefault()
        e.returnValue = ''
      }
    }
  },
}
</script>

<style lang="scss" scoped>
#page-editor {
  display: grid;
  grid-template-columns: 360px 1fr;
  grid-template-areas: 'header header' 'sidenav content';

  #header {
    grid-area: header;
  }

  #sidenav {
    grid-area: sidenav;
  }
}
</style>
